import BookIcon from 'components/icon/icons/BookIcon'
import DiscordIcon from 'components/icon/icons/DiscordIcon'
import QuestionIcon from 'components/icon/icons/QuestionIcon'

// Type
import { Link } from 'components/footer/components/links/links.types'

// URLS
import { DISCORD_LINK, DOCS_LINK, FAQ_LINK } from 'constants/links'

export const SPLASH_LINKS: Link[] = [
  { name: 'Docs', icon: BookIcon, url: DOCS_LINK },
  { name: 'FAQ', icon: QuestionIcon, url: FAQ_LINK },
  { name: 'Discord', icon: DiscordIcon, url: DISCORD_LINK },
]

export const WHO_ARE_WE_FIST = `SafePOKT is a protocol running on Fantom Network. 
                                It allows investors of any kind to invest in Pocket Network Nodes to earn rewards directly from an ERC-20 wallet.`

export const WHO_ARE_WE_SECOND = `Users purchase protocol shares (with USDC or wPOKT) that represent the POKT staked into the running nodes.
                                  The revenue generated from nodes is distributed each epoch to holders according to the shares they own.`
